<template>
  <div :class="[pageClass]">
    <div class="containerLayout">
      <header>
        <img src="@/assets/wavesup.png" alt="wave-up" class="w-full bg-no-repeat">
      </header>
      <main>
        <slot/>
      </main>
      <footer>
        <img src="@/assets/wavesdown.png" alt="wave-up" class="w-full bg-no-repeat pt-2.5">
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DefaultLayout',
  props: {
    pageClass: {
      type: String
    },
  },
};
</script>
<style>
body, html, #app {
  font-family: 'Lato', sans-serif;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background: #2c6a89;
}

header, footer {
  width: 100%;
}

.containerLayout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.defaultPage {
  background-image: url('@/assets/default-background.svg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  width: 100%;
}
</style>
